// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"20ba8d8d","289":"6f04f688","312":"8442649b","433":"67655064","453":"a3412801","567":"9651a540","652":"0a395353","829":"827d02fe","995":"35f40fa3"}[chunkId] + ".chunk.js";
};